import { render, staticRenderFns } from "./contactdocument-close.vue?vue&type=template&id=7fa2e957&scoped=true&"
import script from "./contactdocument-close.vue?vue&type=script&lang=js&"
export * from "./contactdocument-close.vue?vue&type=script&lang=js&"
import style0 from "./contactdocument-close.vue?vue&type=style&index=0&id=7fa2e957&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa2e957",
  null
  
)

export default component.exports